import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import Button from '../atoms/Button';
import css from './TableCellButton.css';

const TableCellButton = ({
    translationId,
    onClick = () => {},
    type = 'secondary',
    row = {},
    rowIndex = null,
    tdClassName = '',
}) => (
    <td className={classNames(css.cell, tdClassName)}>
        <Button type={type} className={css.button} onClick={() => onClick(row, rowIndex)}>
            <Translate id={translationId} />
        </Button>
    </td>
);

TableCellButton.propTypes = {
    translationId: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'link']),
    row: PropTypes.objectOf(PropTypes.any),
    rowIndex: PropTypes.number,
    tdClassName: PropTypes.string,
};

export default TableCellButton;
